import { useCallback } from 'react';

import { SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Button } from 'app/shared/buttons/Button';
import { Input } from 'app/shared/forms/Input';
import { Icons } from 'app/constants/icons';
import { useAuthentication } from 'app/hooks/useAuthentication';
import { cn } from 'app/utils/styles.utils';

// validate regex email
const EMAIL_REGEX = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,12}$/;

type FormProps = {
  email: string;
};

export const EmailConnection = () => {
  const {t} = useTranslation();
  const {connect} = useAuthentication();
  const {register, watch, formState, handleSubmit} = useForm<FormProps>();

  const email = watch('email');

  const handleConnect = useCallback<SubmitHandler<FormProps>>(
    ({email}) => {
      connect('web3_auth', false, {
        loginProvider: 'email_passwordless',
        username: email,
      });
    },
    [connect],
  );

  const isEmailFieldEmpty = !email?.trim().length;

  return (
    <form
      className="relative flex w-full flex-col gap-5"
      onSubmit={handleSubmit(handleConnect)}>
      <Input
        id="email"
        type="text"
        className={cn('pr-[60px]', {
          invalid:
            !isEmailFieldEmpty && !formState.isValid && formState.isSubmitted,
        })}
        autoFocus
        aria-label="Email Address"
        placeholder="Email Address"
        size="xl"
        variant="white-outlined"
        {...register('email', {
          required: true,
          validate: value => EMAIL_REGEX.test(value),
        })}
      />

      <div className="absolute bottom-0 right-2.5 top-0 flex items-center justify-center">
        <Button
          // {...buildEvent('button_login', 'email')}
          type="submit"
          className={
            'flex h-7.5 w-7.5 items-center justify-center rounded-[100%] border-[1px] border-white text-white transition-colors active:opacity-70 disabled:border-[#2B2E34] disabled:text-[#2B2E34] light:border-black light:text-[##9FA1A3] light:text-black light:disabled:border-neutral-80 light:disabled:text-neutral-80'
          }
          disabled={isEmailFieldEmpty}
          aria-label={t('connect.connectWithEmail')}>
          <Icons.chevronRight size={18} />
        </Button>
      </div>
    </form>
  );
};
